export const TRANSACTION_TOPAY = 'toPay';
export const TRANSACTION_DEPOSIT = 'deposit';
export const TRANSACTION_TOTAL = 'total';

export const PURCHASE_METHOD_CASH = 'cash';
export const PURCHASE_METHOD_LEASE = 'lease';
export const PURCHASE_METHOD_FINANCE = 'finance';

export const KEY_CASHDOWN = 'cashDown';
export const KEY_FREQUENCY = 'paymentFrequency';
export const KEY_LIEN = 'lien';
export const KEY_KMPLAN = 'kmPerYearPlan';
export const KEY_TERM = 'term';
export const KEY_TRADEIN = 'tradeIn';

export const KEY_DISPLAY_CASH = 'retail';
export const KEY_DISPLAY_LEASE_FINANCE = 'payment';

export const KEY_META_FREQUENCY = 'paymentFrequencies';
export const KEY_META_KMPLAN = 'kmPerYearPlans';
export const KEY_META_TERM = 'term';

export const PAYMENT_ADJUSTMENT_TYPE = {
    CASH_DOWN: 'cashDown',
    SELLING_PRICE: 'sellingPrice',
    TRADE_IN: 'tradeIn'
};

export const PROFIT_ADJUSTMENT_TYPE = {
    SELLING_PRICE: 'sellingPrice',
    RETAIL_DISCOUNT: 'retailDiscount',
    RETAIL_DISCOUNT_RATE: 'retailDiscountRate',
    COST_MARKUP: 'costMarkup',
    COST_MARKUP_RATE: 'costMarkupRate'
};

export const PAYMENT_FREQUENCIES = {
    "12": "Monthly",
    "24": "Semi-monthly",
    "26": "Bi-weekly",
    "52": "Weekly"
};
